<template>
    <div class="section-box received-payment">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <el-badge :value="invoiceCount.waitOpen" style="margin-right: 25px;" :max="9999">
                    <el-button size="mini" @click="chose(0)"
                        :class="form.OfflineInvoiceStatus == 0 ? 'selected' : ''">待开票</el-button>
                </el-badge>
                <el-badge :value="invoiceCount.opened" style="margin-right: 25px;" :max="9999">
                    <el-button size="mini" @click="chose(1)"
                        :class="form.OfflineInvoiceStatus == 1 ? 'selected' : ''">已开票</el-button>
                </el-badge>
                <el-badge :value="invoiceCount.waitReturn" style="margin-right: 25px;" :max="9999">
                    <el-button size="mini" @click="chose(3)"
                        :class="form.OfflineInvoiceStatus == 3 ? 'selected' : ''">待回款</el-button>
                </el-badge>
                <el-badge :value="invoiceCount.complete" style="margin-right: 25px;" :max="9999">
                    <el-button size="mini" @click="chose(4)"
                        :class="form.OfflineInvoiceStatus == 4 ? 'selected' : ''">已回款</el-button>
                </el-badge>
                <el-badge :value="invoiceCount.reject" style="margin-right: 25px;" :max="9999">
                    <el-button size="mini" @click="chose(2)"
                        :class="form.OfflineInvoiceStatus == 2 ? 'selected' : ''">已拒绝</el-button>
                </el-badge>

            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                <!-- <el-button size="medium" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button> -->
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table ref="tableData" :stripe="true" :data="tableData" style="width: 100%" height="666" border
            v-loading="listLoading">
            <el-table-column label="企微审批单号">
                <el-table-column show-overflow-tooltip width="150" align="center">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.ComWxSpNo" placeholder="企微审批单号" />
                    </template>
                    <template slot-scope="scope">
                        <span :title="scope.row.Id">{{ (scope.row.ComWxSpNo) || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <!-- <el-table-column label="发票Id">
                <el-table-column show-overflow-tooltip width="80" align="center">
               
                    <template slot-scope="scope">
                        <span>{{ scope.row.Id || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column> -->
            <el-table-column label="申请时间">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker size="mini" v-model="form.ComWxApplyTime" type="daterange" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始日期"
                            end-placeholder="结束日期" style="width: 100%;"></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.ComWxApplyTime || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发票抬头">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.InvoiceTitle" placeholder="输入发票抬头搜索" />
                    </template>
                    <template slot-scope="scope">
                        <img :src="icon_sandian" style="width: 15px;float: left;margin-top: 5px;"
                            v-if="scope.row.isEInvoice == 1">
                        <span>{{ scope.row.InvoiceTitle || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="工单Id">
                <el-table-column show-overflow-tooltip width="120">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.JobId" placeholder="工单Id" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ (scope.row.IsJob ? scope.row.JobIdStr : "非工单") || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>

            <el-table-column label="发单客户">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.UserCode" clearable filterable remote placeholder="输入关键字搜索"
                            :remote-method="searchUsersFromMongo" @clear="userList=[]" :loading="searchUserLoading">
                            <el-option v-for="item in userList" :key="item.UserCode" :label="item.UserNameAndCode"
                                :value="item.UserCode">
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.UserName || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>

            <el-table-column label="开票状态">
                <el-table-column show-overflow-tooltip width="150">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.OfflineInvoiceStatus" placeholder="请选择"
                            style="width: 100%;">
                            <el-option :value="item.value" :label="item.name"
                                v-for="(item, index) in OfflineInvoiceStatusArray" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.OfflineInvoiceStatusName || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="开票选项">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.InvoiceContentType" placeholder="请选择平台"
                            style="width: 100%;">
                            <el-option value="0" label="请选择"></el-option>
                            <el-option :value="item.value" :label="item.label"
                                v-for="(item, index) in invoiceContentOptionArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.InvoiceContent || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>

            <el-table-column label="开票金额">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.StartInvoiceMoney" style="width: 45%;" placeholder="搜索"
                            type="number" /> ~
                        <el-input size="mini" v-model="form.EndInvoiceMoney" style="width: 45%;" placeholder="搜索"
                            type="number" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.InvoiceMoney }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="开票时间">
                <el-table-column show-overflow-tooltip width="190">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker size="mini" v-model="form.InvoiceConfirmDt" type="daterange" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始日期"
                            end-placeholder="结束日期" style="width: 100%;"></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ (scope.row.InvoiceConfirmDt) || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
              <el-table-column label="开票公司">
                <el-table-column show-overflow-tooltip width="120">
                    <template slot-scope="scope">
                        <span>{{ ((scope.row.BelongCompanyName=='未知'?'--':scope.row.BelongCompanyName)||'--') }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="已收金额">
                <el-table-column show-overflow-tooltip width="120">
                    <!-- <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.receivedMoneyBegin" style="width: 45%;" placeholder="搜索" type="number"/> ~
                        <el-input size="mini" v-model="form.receivedMoneyEnd" style="width: 45%;" placeholder="搜索" type="number"/>
                    </template> -->
                    <template slot-scope="scope">
                        <span>{{ (scope.row.IsNeedReceiveMoney? scope.row.ReceivedMoney:scope.row.InvoiceMoney) }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
             <el-table-column label="审批备注">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot-scope="scope"> 
                      <span>{{ scope.row.ComWxAuditRemark }}</span> 
                    </template>
                </el-table-column>
            
            </el-table-column>
            <el-table-column label="发票文件">
                <el-table-column show-overflow-tooltip width="150" align="center">
                    <!-- <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.invoiceNumber" placeholder="输入发票编号搜索" />
                    </template> -->
                    <template slot-scope="scope">
                        <a target="_blank" @click="downloadFile(scope.row.InvoiceFileUrl,1)" v-if="scope.row.InvoiceFileUrl">
                            <img style="margin-bottom: -2px;height: 35px;width: auto;" src="@/assets/icon/pdf.png" alt="pdf发票" />
                        </a>
                         <a target="_blank" @click="downloadFile(scope.row.InvoiceXmlFileUrl,2)" v-if="scope.row.InvoiceXmlFileUrl">
                            <img style="margin-bottom: -2px;margin-left: 2px;height: 35px;width: auto;" src="@/assets/icon/xml.png" alt="xml发票" />
                        </a>
                          <a target="_blank" @click="downloadFile(scope.row.InvoiceOfdFileUrl,3)" v-if="scope.row.InvoiceOfdFileUrl">
                            <img style="margin-bottom: -2px;margin-left: 2px;height: 35px;width: auto;" src="@/assets/icon/ofd.png" alt="ofd发票" />
                        </a>
                        <span>{{ (scope.row.InvoiceXmlFileUrl||scope.row.InvoiceFileUrl||scope.row.InvoiceOfdFileUrl||scope.row.InvoiceOfdFileUrl) ? "" :"--"}}</span>
                    </template>
                </el-table-column>
            </el-table-column>

            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <!-- <el-button size="mini" v-if="scope.row.InvoiceFileUrl" @click="downInvoice(scope.row.InvoiceFileUrl)">下单发票</el-button> -->
                    <el-button size="mini" @click="openInvoice(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="form.PageNo" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <OfflineInvoiceDetail ref="detailsInvoice" />
    </div>
</template>

<script>
import OfflineInvoiceDetail from './index/offlineInvoiceDetail'
// import eventBus from "@/utils/eventBus.js";

import {
    GetOfflineInvoiceCount, GetOfflineInvoiceList
} from "@/service/payApi";
import { searchUsersFromMongo } from '@/service/login'
export default {
    components: {
        OfflineInvoiceDetail
    },
    data() {
        return {
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,

                ComWxSpNo: "",
                ComWxApplyTime: [],//申请时间
                InvoiceConfirmDt: [], //开票时间

                UserCode: "",
                InvoiceTitle: "",
                JobId:"",
                OfflineInvoiceStatus: 0, //开票状态, 0待开票，1已开票，2已拒绝，3待回款，4已回款
                InvoiceContentType: "",
                StartInvoiceMoney: "",
                EndInvoiceMoney: "",
               
                ComWxApplyUser: ""
            },
            searchData: {},
            oraginForm: {},
            total: 0,                       //总条数
            tableData: [],

            invoiceCount: {
                waitOpen: 0,
                opened: 0,
                waitReturn: 0,
                complete: 0,
                reject: 0
            },
            invoiceContentOptionArr: [
                {
                    label: "*研发和技术服务*技术服务费",
                    value: 1,
                },
                {
                    label: "*研发和技术服务*技术咨询费",
                    value: 2,
                },
                {
                    label: "*现代服务*技术服务费",
                    value: 3
                },
                {
                    label: "*现代服务*技术咨询费",
                    value: 4
                },
                {
                    label: "*现代服务*现场服务",
                    value: 5
                },
                {
                    label: "*现代服务*现场技术服务",
                    value: 6
                }
            ],
            OfflineInvoiceStatusArray:
                [
                    { name: '全部', value: -1 },
                    { name: '待开票', value: 0 },
                    { name: '已开票', value: 1 },
                    { name: '已拒绝', value: 2 },
                    { name: '待回款', value: 3 },
                    { name: '已回款', value: 4 }
                ],

            searchUserLoading: false,//搜索用户的loadding
            userList: [] //收款账户下来搜索框
        }
    },
    activated() {
        this.getCount();
        this.handleSearch();
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {}, 
    mounted() { },
    methods: { 
        chose(type) {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))

            this.form.PageNo = 1;
            this.form.PageSize = 10;
            this.form.OfflineInvoiceStatus = type;
            console.log('chose.OfflineInvoiceStatus:' + this.form.OfflineInvoiceStatus);
            this.GetInvoiceList();
        },
        getCount() {
            const _this = this
            let data = {}

            GetOfflineInvoiceCount(data).then((r) => {
                console.log("GetOfflineInvoiceCount" + JSON.stringify(r))
                if (r.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                //  //开票状态, 0待开票，1已开票，2已拒绝，3待回款，4已回款
                var temp = r.Data
                for (var i = 0; i < temp.length; i++) {
                    if (temp[i].InvoiceStatus == 0) {
                        this.invoiceCount.waitOpen = temp[i].InvoiceCount
                    }
                    if (temp[i].InvoiceStatus == 1) {
                        this.invoiceCount.opened = temp[i].InvoiceCount
                    }
                    if (temp[i].InvoiceStatus == 2) {
                        this.invoiceCount.reject = temp[i].InvoiceCount
                    }
                    if (temp[i].InvoiceStatus == 3) {
                        this.invoiceCount.waitReturn = temp[i].InvoiceCount
                    }
                    if (temp[i].InvoiceStatus == 4) {
                        this.invoiceCount.complete = temp[i].InvoiceCount
                    }

                }
            })
        },
        //渲染列表
        handleSearch() { 
            this.GetInvoiceList()
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNo = val
            this.searchData.PageNo = val
            this.GetInvoiceList()
        },
        //翻页
        handleSizeChange(val) {
            if (this.listLoading) return
            this.form.PageNo = 1
            this.form.PageSize = val
            this.searchData.PageNo = 1
            this.searchData.PageSize = val
            this.GetInvoiceList()
        },
        // TODO：修改接口名 form参数 table展示数据
        async GetInvoiceList() {
            const _this = this
            this.listLoading = true

            let data = {
                pageNum: this.form.PageNo,
                pageSize: this.form.PageSize,
            }
            data.platform = 'pcweb'

            if (this.form.ComWxSpNo) data.ComWxSpNo = this.form.ComWxSpNo;

            if (_this.form.ComWxApplyTime instanceof Array && _this.form.ComWxApplyTime.length > 0) {
                data.StartComWxApplyTime = _this.form.ComWxApplyTime[0] + " 00:00:00";
                data.EndComWxApplyTime = _this.form.ComWxApplyTime[1] + " 00:00:00";
            }
            else {
                if (data.StartComWxApplyTime) delete data.StartComWxApplyTime;
                if (data.EndComWxApplyTime) delete data.EndComWxApplyTime;
            }
 
            if (this.form.InvoiceTitle) data.InvoiceTitle = this.form.InvoiceTitle;
            if (this.form.JobId) data.JobId = this.form.JobId;
 
            if (_this.form.InvoiceConfirmDt instanceof Array && _this.form.InvoiceConfirmDt.length > 0) {
                data.StartInvoiceConfirmDt = _this.form.InvoiceConfirmDt[0] + " 00:00:00";
                data.EndInvoiceConfirmDt = _this.form.InvoiceConfirmDt[1] + " 00:00:00";
            } else {
                if (data.StartInvoiceConfirmDt) delete data.StartInvoiceConfirmDt;
                if (data.EndInvoiceConfirmDt) delete data.EndInvoiceConfirmDt;
            }

            // if(this.form.invoiceContentType&&this.form.invoiceContentType>0) data.invoiceContentType = this.form.invoiceContentType
            // if(this.form.invoiceMoneyBegin) data.invoiceMoneyBegin = this.form.invoiceMoneyBegin
            // if(this.form.invoiceMoneyEnd) data.invoiceMoneyEnd = this.form.invoiceMoneyEnd
            // if(this.form.invoiceTitle) data.invoiceTitle = this.form.invoiceTitle
            // if(this.form.receivableMoneyBegin) data.receivableMoneyBegin = this.form.receivableMoneyBegin
            // if(this.form.receivableMoneyEnd) data.receivableMoneyEnd = this.form.receivableMoneyEnd
            // if(this.form.receivedMoneyBegin) data.receivedMoneyBegin = this.form.receivedMoneyBegin
            // if(this.form.receivedMoneyEnd) data.receivedMoneyEnd = this.form.receivedMoneyEnd
            // if(this.form.taxPointId) data.taxPointId = this.form.taxPointId
            if (this.form.UserCode) data.UserCode = this.form.UserCode;
            // if(this.form.invoiceNumber) data.invoiceNumber = this.form.invoiceNumber
            if (this.form.OfflineInvoiceStatus > -1) data.OfflineInvoiceStatus = this.form.OfflineInvoiceStatus;
            if (this.form.InvoiceContentType > 0) data.InvoiceContentType = this.form.InvoiceContentType;
 
            if (this.form.StartInvoiceMoney) data.StartInvoiceMoney = this.form.StartInvoiceMoney;
            if (this.form.EndInvoiceMoney) data.EndInvoiceMoney = this.form.EndInvoiceMoney;
 

            console.log('form.OfflineInvoiceStatus:' + this.form.OfflineInvoiceStatus);
            console.log('data.OfflineInvoiceStatus:' + data.OfflineInvoiceStatus);

            let res = await GetOfflineInvoiceList(data)
            this.getCount(); //获取数量
            this.listLoading = false
            if (res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.InvoiceList; 
            this.total = res.Data.TotalCount;

            this.$nextTick(() => {
                this.$refs.tableData.doLayout()
            })
        },

        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
        // 点击详情
        openInvoice(row) {
            console.log('id:'+row.Id);
            this.$refs.detailsInvoice.open(row.Id)
        },
          //使用XHR方式下载xml文件，解决部分浏览器下载问题
        downloadFile(url, tt) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            
            xhr.onload = function() {
                if (xhr.status === 200) {
                const blob = xhr.response;
                const blobUrl = URL.createObjectURL(blob);
                
                const link = document.createElement('a');
                link.href = blobUrl;

                var name='';
                if(tt==1)
                {
                    name = 'invoice.pdf';
                }
                else if(tt==2)
                {
                    name = 'invoice.xml';
                }
                else if(tt==3)
                {
                    name = 'invoice.ofd';
                }

                link.download = name;
                link.style.display = 'none';
                
                document.body.appendChild(link);
                link.click();
                
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
                }
            };
            
            xhr.onerror = function() {
                console.error('下载失败');
            };
            xhr.send();
        },
        //从mongo获取用户
        searchUsersFromMongo(userName) {
            if (userName != "") {
                this.searchUserLoading = true;
                var that = this;
                console.log('---searchUsersFromMongo--');
                setTimeout(() => {
                    var data = {
                        PageNum: 1,
                        PageSize: 100,
                        UserType: 0,
                        UserName: userName
                    };
                    console.log('data:' + JSON.stringify(data));
                    let res = searchUsersFromMongo(data).then(res => {
                        that.searchUserLoading = false;
                        if (res.Result != 1) {
                            return this.$message.error(res.Message);
                        }
                        that.userList = res.Data;
                        console.log("userList:" + JSON.stringify(that.userList));

                    });

                }, 200);
            }
            else {
                this.userList = [];
            }
        }
    }
}
</script>

<style lang="scss">
.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.row-bg {
    padding: 10px 14px;
    background-color: #f9fafc;
}

.received-payment {
    .selected {
        color: #409EFF;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
    }
}
</style>